export const apiPaths = {
  administrationList: '/api/main/getAdministrationList',
  throughSchoolList: '/api/main/getThroughSchoolList',
  mainSession: '/api/main/getSession',
  registerMessage: '/api/main/register/message',
  registerCaptcha: '/api/main/register/verify',
  checkSchoolName: '/api/main/check/schoolName',
  checkSchoolNameByName: '/api/main/check/checkSchoolNameByName',
  checkSlug: '/api/main/check/slug',
  updatedFiles: '/api/pclab/getUpdatedFiles',
  latestVersion: '/api/pclab/getLastestVersion',
  allVersions: '/api/pclab/getAllVersions',
  releaseVersion: '/api/pclab/releaseVersion',
  addDownloadRecord: '/api/pclab/download/addDownloadRecord',
  activeUserNumberByRange: '/api/main/activeUserStatistics/getActiveUserNumberByRange',
  activeUserNumberByDate: '/api/main/activeUserStatistics/getUserActiveNumByDate',
  courseStatisticsBySchool: '/api/main/activeUserStatistics/getCourseStatisticsBySchool',
  courseStatisticsByDate: '/api/main/activeUserStatistics/getCourseStatisticsByDate',
  adminSession: '/api/admin/user/adminSession',
  ssoLoginUrl: '/api/admin/user/getssoLoginUrl',
  schoolValidToken: '/api/admin/user/schoolValidToken',
  ssoExchange: '/api/admin/user/sso/exchange',
  schoolSlugByOrgCode: '/api/main/sso/school/getSchoolSlugbyOrgCode',
  schoolSlugByID: '/api/main/sso/school/getSchoolSlugbyID',
  schoolInfoKS: '/api/main/sso/ks/getSchoolInfo',
  fileUpload: '/api/file/upload',
  pclabFileUpload: '/api/file/uploadPclabFile',
} as const;
